export const Assets = {
    BTC: 1,
    ETH: 2,
}